export const firebaseConfig = {
  apiKey: "AIzaSyBjrcVrkJk22BUliEcdw7HYqUaPWAZTqSg",
  authDomain: "airflow-investing.firebaseapp.com",
  databaseURL: "https://airflow-investing.firebaseio.com",
  projectId: "airflow-investing",
  storageBucket: "airflow-investing.appspot.com",
  messagingSenderId: "119860168996",
  appId: "1:119860168996:web:bded9b7d6e37a93f8dcbb1",
  measurementId: "G-2XKMPJ5DBX"
};
